module.exports = __webpack_public_path__ + "static/media/exchangeIcon.afea60df.svg";